import template from './product-check-aggregate.template.html';
import controller from './product-check-aggregate.controller';
import './product-check-aggregate.scss';

export default {
  template,
  controller,
};



// WEBPACK FOOTER //
// ./src/app/product/product-check/product-check-aggregate/product-check-aggregate.component.js